module.exports = __webpack_public_path__ + "img/40_69_005_720.2affbfd2.jpg";